import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import MenuUpsellItemCard from 'base-ordering/components/MenuUpsellItemCard';

function MenuUpsellItem({ name, images = [], defaultPrice }) {
  const image = get(images, '[0]');

  return <MenuUpsellItemCard name={name} price={defaultPrice} image={image} />;
}

MenuUpsellItem.propTypes = {
  name: PropTypes.string.isRequired,
  images: PropTypes.array,
  defaultPrice: PropTypes.string.isRequired
};

export default MenuUpsellItem;
